import EventDownloadReportButton from './event-download-report';


const EventActionItems = {
    DownloadReport: EventDownloadReportButton,
};


export default EventActionItems;